/* eslint-disable eqeqeq,no-param-reassign,@typescript-eslint/no-shadow,@typescript-eslint/no-unused-vars */

xplenty.directive('pageHeader', [
  '$compile',
  function ($compile) {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('../../../views/directives/page-header.html'),

      replace: true,

      compile: function compile(element, attrs) {
        return {
          pre: function preLink(scope, element, attrs, controller) {
            if (attrs.injector) {
              const injector = $(attrs.injector);

              element.find('#page-header-injector').html(injector.html());

              injector.remove();
            }
          },
          post: function postLink(scope, element, attrs, controller) {
            scope.hasBack = attrs.back == 'true' || scope.hasBack;

            $compile(element)(scope);
          },
        };
      },

      controller: ['$scope', function ($scope) {}],
    };
  },
]);
